// extracted by mini-css-extract-plugin
module.exports = {"title":"canvas-node-auto_title__3ufOd","icon":"canvas-node-auto_icon__ROD92"};